import { api } from "./api";
import { t } from "./i18n";

export async function renderMcpAccess(el: HTMLElement): Promise<void> {
  try {
    const state = await api.mcpKey();
    draw(el, state);
  } catch (error: any) {
    el.innerHTML = `<p class="hint">${escapeHtml(error?.message || "MCP access unavailable")}</p>`;
  }
}

function draw(el: HTMLElement, state: any, revealedToken = ""): void {
  const limits = state.limits || {};
  const isCreditBudget = limits.limit_type === "daily_credits";
  const limitValue = Number(
    isCreditBudget ? limits.daily_credits : limits.requests_limit,
  );
  const limitText = limitValue === 0
    ? t("mcp.unlimited")
    : isCreditBudget
      ? t("mcp.budget", { count: limitValue })
      : t("mcp.limit", {
          count: limitValue,
          seconds: Number(limits.window_seconds),
        });
  el.innerHTML = `
    <h2>${t("mcp.title")}</h2>
    <p class="hint">${t("mcp.description")}</p>
    <dl class="kv">
      <dt>${t("mcp.tier")}</dt><dd>${escapeHtml(limits.tier_name || "Free")}</dd>
      <dt>${t("mcp.rate")}</dt><dd>${escapeHtml(limitText)}</dd>
      ${state.has_key ? `<dt>${t("mcp.key")}</dt><dd><code>…${escapeHtml(state.token_suffix)}</code></dd>` : ""}
    </dl>
    ${revealedToken ? `
      <div class="api-key-reveal">
        <p class="hint">${t("mcp.shown_once")}</p>
        <code class="api-key-value">${escapeHtml(revealedToken)}</code>
        <button class="btn ghost" id="copy-mcp-key">${t("mcp.copy")}</button>
      </div>` : ""}
    <div class="row" style="margin-top:14px">
      <button class="btn" id="rotate-mcp-key">${state.has_key ? t("mcp.rotate") : t("mcp.create")}</button>
      ${state.has_key ? `<button class="btn ghost" id="revoke-mcp-key">${t("mcp.revoke")}</button>` : ""}
    </div>
  `;

  el.querySelector<HTMLButtonElement>("#rotate-mcp-key")!.addEventListener("click", async () => {
    if (state.has_key && !window.confirm(t("mcp.confirm_rotate"))) return;
    try {
      const created = await api.rotateMcpKey();
      draw(el, created, created.token);
    } catch (error: any) {
      window.alert(error?.message || "MCP key error");
    }
  });
  el.querySelector<HTMLButtonElement>("#revoke-mcp-key")?.addEventListener("click", async () => {
    if (!window.confirm(t("mcp.confirm_revoke"))) return;
    try {
      await api.revokeMcpKey();
      await renderMcpAccess(el);
    } catch (error: any) {
      window.alert(error?.message || "MCP key error");
    }
  });
  el.querySelector<HTMLButtonElement>("#copy-mcp-key")?.addEventListener("click", async event => {
    await navigator.clipboard.writeText(revealedToken);
    (event.currentTarget as HTMLButtonElement).textContent = t("mcp.copied");
  });
}

function escapeHtml(value: unknown): string {
  return String(value ?? "").replace(
    /[&<>"']/g,
    char => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[char]!),
  );
}